import { Type } from '@sinclair/typebox';
import { ZxyRegistrationStates } from '../../enums/RegistrationStates';
import { createPathStringParameter } from '../../routes/createPathParameter';

export const zxyRegisterPaths = {
    '/api/registrations': {
        get: {
            operationId: 'zxyRegisterController.getAll',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    id: Type.String(),
                                    hostname: Type.String(),
                                    name: Type.String(),
                                    apiPath: Type.String(),
                                    secretKey: Type.String(),
                                    isZxyCloudClient: Type.Boolean(),
                                    zxyClientCompanyId: Type.String(),
                                    zxyClientCompanyName: Type.String(),
                                    isAllowedReadObjectList: Type.Boolean(),
                                    isAllowedReadSurveyList: Type.Boolean(),
                                    isAllowedReadObjectData: Type.Boolean(),
                                    isAllowedReadSurveyData: Type.Boolean(),
                                    isAllowedUpdateObject: Type.Boolean(),
                                    isAllowedAddObject: Type.Boolean(),
                                    isAllowedAddSurvey: Type.Boolean(),
                                    isProduction: Type.Boolean(),
                                    status: Type.Enum(ZxyRegistrationStates),
                                    created_at: Type.String(),
                                    updated_at: Type.String(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'zxyRegisterController.create',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    id: Type.String(),
                                    hostname: Type.String(),
                                    name: Type.String(),
                                    apiPath: Type.String(),
                                    secretKey: Type.String(),
                                    isZxyCloudClient: Type.Boolean(),
                                    zxyClientCompanyId: Type.String(),
                                    zxyClientCompanyName: Type.String(),
                                    isAllowedReadObjectList: Type.Boolean(),
                                    isAllowedReadSurveyList: Type.Boolean(),
                                    isAllowedReadObjectData: Type.Boolean(),
                                    isAllowedReadSurveyData: Type.Boolean(),
                                    isAllowedUpdateObject: Type.Boolean(),
                                    isAllowedAddObject: Type.Boolean(),
                                    isAllowedAddSurvey: Type.Boolean(),
                                    isProduction: Type.Boolean(),
                                    status: Type.Enum(ZxyRegistrationStates),
                                    created_at: Type.String(),
                                    updated_at: Type.String(),
                                }),
                            ),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            hostname: Type.String(),
                            name: Type.String(),
                            apiPath: Type.String(),
                            secretKey: Type.String(),
                            isZxyCloudClient: Type.Boolean(),
                            zxyClientCompanyId: Type.String(),
                            zxyClientCompanyName: Type.String(),
                            isAllowedReadObjectList: Type.Boolean(),
                            isAllowedReadSurveyList: Type.Boolean(),
                            isAllowedReadObjectData: Type.Boolean(),
                            isAllowedReadSurveyData: Type.Boolean(),
                            isAllowedUpdateObject: Type.Boolean(),
                            isAllowedAddObject: Type.Boolean(),
                            isAllowedAddSurvey: Type.Boolean(),
                            isProduction: Type.Boolean(),
                            status: Type.Enum(ZxyRegistrationStates),
                            created_at: Type.String(),
                            updated_at: Type.String(),
                        }),
                    },
                },
            },
        },
    },
    '/api/registrationsHost': {
        get: {
            operationId: 'zxyRegisterController.getOneByHostname',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.String(),
                                hostname: Type.String(),
                                name: Type.String(),
                                apiPath: Type.String(),
                                secretKey: Type.String(),
                                isZxyCloudClient: Type.Boolean(),
                                zxyClientCompanyId: Type.String(),
                                zxyClientCompanyName: Type.String(),
                                isAllowedReadObjectList: Type.Boolean(),
                                isAllowedReadSurveyList: Type.Boolean(),
                                isAllowedReadObjectData: Type.Boolean(),
                                isAllowedReadSurveyData: Type.Boolean(),
                                isAllowedUpdateObject: Type.Boolean(),
                                isAllowedAddObject: Type.Boolean(),
                                isAllowedAddSurvey: Type.Boolean(),
                                isProduction: Type.Boolean(),
                                status: Type.Enum(ZxyRegistrationStates),
                                created_at: Type.String(),
                                updated_at: Type.String(),
                            }),
                        },
                    },
                },
            },
        },
    },
    '/api/registrationsClient': {
        get: {
            operationId: 'zxyRegisterController.getOneByClientCompanyId',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.String(),
                                hostname: Type.String(),
                                name: Type.String(),
                                apiPath: Type.String(),
                                secretKey: Type.String(),
                                isZxyCloudClient: Type.Boolean(),
                                zxyClientCompanyId: Type.String(),
                                zxyClientCompanyName: Type.String(),
                                isAllowedReadObjectList: Type.Boolean(),
                                isAllowedReadSurveyList: Type.Boolean(),
                                isAllowedReadObjectData: Type.Boolean(),
                                isAllowedReadSurveyData: Type.Boolean(),
                                isAllowedUpdateObject: Type.Boolean(),
                                isAllowedAddObject: Type.Boolean(),
                                isAllowedAddSurvey: Type.Boolean(),
                                isProduction: Type.Boolean(),
                                status: Type.Enum(ZxyRegistrationStates),
                                created_at: Type.String(),
                                updated_at: Type.String(),
                            }),
                        },
                    },
                },
            },
        },
    },
    '/api/registrations/{registrationIdOrKey}': {
        parameters: [createPathStringParameter('registrationIdOrKey')],
        get: {
            operationId: 'zxyRegisterController.getOne',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.String(),
                                hostname: Type.String(),
                                name: Type.String(),
                                apiPath: Type.String(),
                                secretKey: Type.String(),
                                isZxyCloudClient: Type.Boolean(),
                                zxyClientCompanyId: Type.String(),
                                zxyClientCompanyName: Type.String(),
                                isAllowedReadObjectList: Type.Boolean(),
                                isAllowedReadSurveyList: Type.Boolean(),
                                isAllowedReadObjectData: Type.Boolean(),
                                isAllowedReadSurveyData: Type.Boolean(),
                                isAllowedUpdateObject: Type.Boolean(),
                                isAllowedAddObject: Type.Boolean(),
                                isAllowedAddSurvey: Type.Boolean(),
                                isProduction: Type.Boolean(),
                                status: Type.Enum(ZxyRegistrationStates),
                                created_at: Type.String(),
                                updated_at: Type.String(),
                            }),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'zxyRegisterController.update',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    id: Type.String(),
                                    hostname: Type.String(),
                                    name: Type.String(),
                                    apiPath: Type.String(),
                                    secretKey: Type.String(),
                                    isZxyCloudClient: Type.Boolean(),
                                    zxyClientCompanyId: Type.String(),
                                    zxyClientCompanyName: Type.String(),
                                    isAllowedReadObjectList: Type.Boolean(),
                                    isAllowedReadSurveyList: Type.Boolean(),
                                    isAllowedReadObjectData: Type.Boolean(),
                                    isAllowedReadSurveyData: Type.Boolean(),
                                    isAllowedUpdateObject: Type.Boolean(),
                                    isAllowedAddObject: Type.Boolean(),
                                    isAllowedAddSurvey: Type.Boolean(),
                                    isProduction: Type.Boolean(),
                                    status: Type.Enum(ZxyRegistrationStates),
                                    created_at: Type.String(),
                                    updated_at: Type.String(),
                                }),
                            ),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            id: Type.String(),
                            hostname: Type.String(),
                            name: Type.String(),
                            apiPath: Type.String(),
                            secretKey: Type.String(),
                            isZxyCloudClient: Type.Boolean(),
                            zxyClientCompanyId: Type.String(),
                            zxyClientCompanyName: Type.String(),
                            isAllowedReadObjectList: Type.Boolean(),
                            isAllowedReadSurveyList: Type.Boolean(),
                            isAllowedReadObjectData: Type.Boolean(),
                            isAllowedReadSurveyData: Type.Boolean(),
                            isAllowedUpdateObject: Type.Boolean(),
                            isAllowedAddObject: Type.Boolean(),
                            isAllowedAddSurvey: Type.Boolean(),
                            isProduction: Type.Boolean(),
                            status: Type.Enum(ZxyRegistrationStates),
                            created_at: Type.String(),
                            updated_at: Type.String(),
                        }),
                    },
                },
            },
        },
    },
    '/api/registrations/requestAuthorization': {
        post: {
            operationId: 'zxyRegisterController.requestAuthorization',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                authorized: Type.Boolean(),
                                authorizationId: Type.Optional(Type.String()),
                                message: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            key: Type.String(),
                            recipientId: Type.String(),
                            requestType: Type.String(),
                        }),
                    },
                },
            },
        },
    },
} as const;
